<div class="title">
  <span>{{ title | translate }}</span>
</div>

<div class="switch">
  <ng-content></ng-content>
</div>
